/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { CsrfTokenState } from './types'

export const initialState: CsrfTokenState = {
  token: null,
  lastUpdatedAt: 0
}
